export default __webpack_public_path__ + "static/media/mail_disabled.56947048.svg";